/**
 * A long clip waiting for a go-ahead before its analysis (Dax, 2026-10-06): how long it is, and one button that
 * says how long the analysis would take and starts it. The yes stays on the clip, so it is asked only once.
 */
import { useMutation } from '@tanstack/react-query';
import { analyseDurationWords } from '@studio/contracts';
import { queryClient, trpc } from '@/lib/trpc';

const MIN = 60_000;

export function HeldClip({ assetId, durationMs, estimateMs, reason }: { assetId: string; durationMs: number | null; estimateMs: number | null; reason: string | null }) {
  const proceed = useMutation(trpc.assets.proceed.mutationOptions({
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: trpc.library.pathKey() }),
        queryClient.invalidateQueries({ queryKey: trpc.upload.mine.queryKey() }),
        queryClient.invalidateQueries({ queryKey: trpc.assets.pathKey() }),
      ]);
    },
  }));
  return (
    <span className="row held-clip" onClick={(e) => e.stopPropagation()}>
      {reason === 'long' && <span className="chip warn" title="A long clip waits for your go-ahead: its analysis takes a while">Long clip{durationMs ? ` · ${Math.round(durationMs / MIN)} min` : ''}</span>}
      <button type="button" className="btn" disabled={proceed.isPending} onClick={() => proceed.mutate({ assetId })}>
        {proceed.isPending ? 'Starting…' : `Proceed with analysis${estimateMs ? ` · ${analyseDurationWords(estimateMs)}` : ''}`}
      </button>
      {proceed.isError && <span className="error">{proceed.error.message}</span>}
    </span>
  );
}
